import {
    TgConversation,
    TgConvType,
    TgMember,
    TgMsg,
    TgMsgGroup,
    TgPagination,
    TgState,
    TgChatGroup,
    SearchChatByUser,
    TgChatToSearch
} from "@/store/modules/telegram/types";
import { ActionContext, ActionTree, GetterTree, Module, MutationTree } from "vuex";
import { RootState } from "@/store/types";
import { tgAPI } from "@/api/telegram";
import { TgChannel, TgChat, TgUser } from './types';


export const moduleName = "telegram";

export enum TgGetters {
    getConvList = "GET_CONV_LIST",
    getIsConvLoading = "GET_IS_CONV_LOADING",
    getConvAllLoaded = "GET_CONV_ALL_LOADED",
    getChannelList = "GET_CHANNEL_LIST",
    getIsChannelLoading = "GET_IS_CHANNEL_LOADING",
    getChannelAllLoaded = "GET_CHANNEL_ALL_LOADED",
    getChatList = "GET_CHAT_LIST",
    getIsChatLoading = "GET_IS_CHAT_LOADING",
    getChatAllLoaded = "GET_CHAT_ALL_LOADED",
    getUserList = "GET_USER_LIST",
    getIsUserLoading = "GET_IS_USER_LOADING",
    getUserAllLoaded = "GET_USER_ALL_LOADED",
    getConvPagination = "GET_CONV_PAGINATION",
    getChannelPagination = "GET_CHANNEL_PAGINATION",
    getChatPagination = "GET_CHAT_PAGINATION",
    getUserPagination = "GET_USER_PAGINATION",
    getMsgListMap = "GET_MSG_MAP",
    getSelectedConv = "GET_SELECTED_CONV",
    getSelectedConvType = "GET_SELECTED_CONV_TYPE",
    getIsMsgListLoading = "GET_IS_MSG_LIST_LOADING",
    getIsMsgListAllLoadedByConvId = "GET_IS_MSG_ALL_LOADED_BY_CONV_ID",
    getMsgGroupByConvId = "GET_MSG_LIST_BY_CONV_ID",
    getMemberList = "GET_MEMBER_LIST",
    getIsMemberListLoading = "GET_IS_MEMBER_LIST_LOADING",
    getSelectMenu = "GET_SELECT_MENU",
    getMeId = "GET_ME_ID",
    getIdList = "GET_ID_LIST",
    getMeIdIsLoading = "GET_ME_ID_IS_LOADING",
    getIsPaticipantsLoading = "GET_IS_PATICIPANS_LOADING",
    getIsPaticipantsAllLoadedByName = "GET_IS_PATICIPANS_ALL_LOADED_BY_NAME",
    getChatroomGroupByName = "GET_CHATROOM_GROUP_BY_NAME",

    getSearchTarget = "GET_SEARCH_TARGET",
    getSearchType = "GET_SEARCH_TYPE",
    getSearchContactList = "GET_SEARCH_CONTACT_LIST",
    getSearchConvList = "GET_SEARCH_CONV_LIST",
    getSearchChatList = "GET_SEARCH_CHAT_LIST",
    getIsSearchContactLoading = "GET_IS_SEARCH_CONTACT_LOADING",
    getIsSearchConvLoading = "GET_IS_SEARCH_CONV_LOADING",
    getIsSearchChatLoading = "GET_IS_SEARCH_CHAT_LOADING",
    getIsSearchContactAllLoaded = "GET_IS_SEARCH_CONTACT_ALL_LOADED",
    getIsSearchConvAllLoaded = "GET_IS_SEARCH_CONV_ALL_LOADED",
    getIsSearchChatAllLoaded = "GET_IS_SEARCH_CHAT_ALL_LOADED",
    getSearchContactPagination = "GET_SEARCH_CONTACT_PAGINATION",
    getSearchConvPagination = "GET_SEARCH_CONV_PAGINATION",
    getSearchChatPagination = "GET_SEARCH_CHAT_PAGINATION",
    getSearchMsgListMap = "GET_SEARCH_MSG_MAP",
    getIsSearchMsgLoading = "GET_IS_SEARCH_MSG_LOADING",
    getIsSearchMsgListAllLoadedByConvId = "GET_IS_SEARCH_MSG_ALL_LOADED_BY_CONV_ID",

}

export enum TgMutations {
    setConvList = "SET_CONV_LIST",
    setIsConvLoading = "SET_IS_CONV_LOADING",
    setConvAllLoaded = "SET_CONV_ALL_LOADED",
    setChannelList = "SET_CHANNEL_LIST",
    setIsChannelLoading = "SET_IS_CHANNEL_LOADING",
    setChannelAllLoaded = "SET_CHANNEL_ALL_LOADED",
    setChatList = "SET_CHAT_LIST",
    setIsChatLoading = "SET_IS_CHAT_LOADING",
    setChatAllLoaded = "SET_CHAT_ALL_LOADED",
    setUserList = "SET_USER_LIST",
    setIsUserLoading = "SET_IS_USER_LOADING",
    setUserAllLoaded = "SET_USER_ALL_LOADED",

    setConvPagination = "SET_CONV_PAGINATION",
    setChannelPagination = "SET_CHANNEL_PAGINATION",
    setChatPagination = "SET_CHAT_PAGINATION",
    setUserPagination = "SET_USER_PAGINATION",
    setSelectedConv = "SET_SELECTED_CONV",
    setSelectedConvType = "SET_SELECTED_CONV_TYPE",
    setIsMsgListLoading = "SET_IS_MSG_LIST_LOADING",
    setMsgListByConvId = "SET_MSG_LIST_BY_CONV_ID",
    setMsgPaginationByConvId = "SET_MSG_PAGINATION_BY_CONV_ID",
    setMsgAllLoadedByConvId = "SET_MSG_ALL_LOADED_BY_CONV_ID",
    setMemberList = "SET_MEMBER_LIST",
    setIsMemberListLoading = "SET_IS_MEMBER_LIST_LOADING",
    resetAll = "RESET_ALL",
    setSelectMenu = "SET_SELECT_MENU",
    setMeId = "SET_ME_ID",
    setIdList = "SET_ID_LIST",
    setMeIdIsLoading = "SET_ME_ID_IS_LOADING",

    setIsPaticipantsLoading = "SET_IS_PATICIPANtS_LOADING",
    setChatroomGroupByName = "SET_CHATROOM_GROUP_BY_NAME",
    setParticipantsAllLoadedByName = "SET_PATICIPANtS_ALL_LOADED_BY_NAME",
    setParticipantsPaginationByName = "SET_PATICIPANtS_PAGINATION_BY_NAME",

    setSearchType = "SET_SEARH_TYPE",
    setSearchTarget = "SET_SEARH_TARGET",
    setSearchContactList = "SET_SEARCH_CONTACT_LIST",
    setSearchConvList = "SET_SEARCH_CONV_LIST",
    setSearchChatList = "SET_SEARCH_CHAT_LIST",
    setIsSearchContactLoading = "SET_IS_SEARCH_CONTACT_LOADING",
    setIsSearchConvLoading = "SET_IS_SEARCH_CONV_LOADING",
    setIsSearchChatLoading = "SET_IS_SEARCH_CHAT_LOADING",
    setIsSearchContactAllLoaded = "SET_IS_SEARCH_CONTACT_ALL_LOADED",
    setIsSearchConvAllLoaded = "SET_IS_SEARCH_CONV_ALL_LOADED",
    setIsSearchChatAllLoaded = "SET_IS_SEARCH_CHAT_ALL_LOADED",
    setSearchContactPagination = "SGET_SEARCH_CONTACT_PAGINATION",
    setSearchConvPagination = "SET_SEARCH_CONV_PAGINATION",
    setSearchChatPagination = "SET_SEARCH_CHAT_PAGINATION",
    setSearchMsgListByConvId = "SET_SEARCH_MSG_LIST_BY_CONV_ID",
    setIsSearchMsgLoading = "SET_IS_SEARCH_MSG_LOADING",
    setSearchMsgPaginationByConvId = "SET_SEARCH_MSG_PAGINATION_BY_CONV_ID",
    setSearchMsgAllLoadedByConvId = "SET_SEARCH_MSG_ALL_LOADED_BY_CONV_ID",
    resetSearch = "RESET_SEARCH",
}

export enum TgActions {
    asyncGetConvListByUidAndTgId = "ASYNC_GET_CONV_LIST_BY_UID_AND_TG_ID",
    asyncGetChannelListByUidAndTgId = "ASYNC_GET_CHANNEL_LIST_BY_UID_AND_TG_ID",
    asyncGetChatListByUidAndTgId = "ASYNC_GET_CHAT_LIST_BY_UID_AND_TG_ID",
    asyncGetUserListByUidAndTgId = "ASYNC_GET_USER_LIST_BY_UID_AND_TG_ID",
    asyncGetMsgListByTgIdAndConvId = "ASYNC_GET_MSG_LIST_BY_TG_ID_AND_CONV_ID",
    // asyncGetChannelMembersByTgIdAndConvId = "ASYNC_GET_CHANNEL_MEMBERS_BY_TG_ID_AND_CONV_ID",
    // asyncGetGroupMembersByTgIdAndConvId = "ASYNC_GET_GROUP_MEMBERS_BY_TG_ID_AND_CONV_ID",
    asyncGetParticipantsByUidAndTgIdAndConvId = "  ASYNC_GET_PARTICIPANTS_BY_UID_AND_TG_ID_AND_CONV_ID",
    asyncGetMeId = "ASYNC_GET_ME_ID",
    asyncGetSearchingContactByUidAndTgId = "ASYNC_GET_SEARCHING_CONTACT_BY_Uid_AND_TG_ID",
    asyncGetSearchingConvByUidAndTgId = "ASYNC_GET_SEARCHING_CONV_BY_Uid_AND_TG_ID",
    asyncGetSearchingChatByUidAndTgId = "ASYNC_GET_SEARCHING_CHAT_BY_Uid_AND_TG_ID",
    asyncGetSearchingMsgByConvIdAndTarget = "ASYNC_GET_SEARCHING_MSG_BY_CONV_ID_AND_TARGET",
    asyncGetSearchingMsgByConvIdAndUserId = "ASYNC_GET_SEARCHING_MSG_BY_CONV_ID_AND_USER_ID",
}

const defaultPagination: TgPagination = {
    page: 1,
    limit: 10,
}

const defaultConv: TgConversation = {
    ConversationID: -1,
    Title: "",
    Name: "",
    Phone: "",
    // TODO to be changed to all boolean after backend fulfilled
    Bot: false,
    Type: "user",
}

const defaultState: TgState = {
    meId: 0,
    idList: [],
    meIdIsLoading: false,
    seletedMenu: '1',
    convList: [],
    channelList: [],
    chatList: [],
    UserList: [],
    isConvLoading: false,
    isConvAllLoaded: false,
    isChannelLoading: false,
    isChannelAllLoaded: false,
    isChatLoading: false,
    isChatAllLoaded: false,
    isUserLoading: false,
    isUserAllLoaded: false,
    selectedConv: null,
    selectedConvType: '',
    convPagination: { ...defaultPagination },
    channelPagination: { ...defaultPagination },
    chatPagination: { ...defaultPagination },
    userPagination: { ...defaultPagination },
    isMsgListLoading: false,
    msgListMap: {},
    isParticipantsLoading: false,
    chatroomParticipantsMap: {},
    memberList: [],
    isMemberLoading: false,
    searchType: "",
    searchTarget: "",
    searchingContact: [],
    searchingConversation: [],
    searchingChat: [],
    isSearchingContactLoading: false,
    isSearchingConvLoading: false,
    isSearchingChatLoading: false,
    isSearchingContactAllLoaded: false,
    isSearchingConvAllLoaded: false,
    isSearchingChatAllLoaded: false,
    searchingContactPagination: { ...defaultPagination },
    searchingConvPagination: { ...defaultPagination },
    searchingChatPagination: { ...defaultPagination },
    searchMsgListMap: {},
    isSearchingMsgLoading: false,
}

const state = {
    ...defaultState,
}

export const getters: GetterTree<TgState, RootState> = {
    [TgGetters.getConvList](state): TgConversation[] {
        return state.convList;
    },
    [TgGetters.getIsConvLoading](state): boolean {
        return state.isConvLoading;
    },
    [TgGetters.getConvAllLoaded](state): boolean {
        return state.isConvAllLoaded;
    },
    [TgGetters.getChannelList](state): TgChannel[] {
        return state.channelList;
    },
    [TgGetters.getIsChannelLoading](state): boolean {
        return state.isChannelLoading;
    },
    [TgGetters.getChannelAllLoaded](state): boolean {
        return state.isChannelAllLoaded;
    },

    [TgGetters.getChatList](state): TgChat[] {
        return state.chatList;
    },
    [TgGetters.getIsChatLoading](state): boolean {
        return state.isChatLoading;
    },
    [TgGetters.getChatAllLoaded](state): boolean {
        return state.isChatAllLoaded;
    },
    [TgGetters.getUserList](state): TgUser[] {
        return state.UserList;
    },
    [TgGetters.getIsUserLoading](state): boolean {
        return state.isUserLoading;
    },
    [TgGetters.getUserAllLoaded](state): boolean {
        return state.isUserAllLoaded;
    },

    [TgGetters.getConvPagination](state): TgPagination {
        return state.convPagination;
    },
    [TgGetters.getChannelPagination](state): TgPagination {
        return state.channelPagination;
    },
    [TgGetters.getChatPagination](state): TgPagination {
        return state.chatPagination;
    },
    [TgGetters.getUserPagination](state): TgPagination {
        return state.userPagination;
    },
    [TgGetters.getSelectedConv](state): TgConversation | TgChannel | TgChat | TgUser | null {
        return state.selectedConv;
    },
    [TgGetters.getSelectedConvType](state): string {
        return state.selectedConvType;
    },
    [TgGetters.getIsMsgListLoading](state): boolean {
        return state.isMsgListLoading;
    },
    [TgGetters.getMsgGroupByConvId]: (state) => (convId: number): TgMsgGroup => {
        if (state.msgListMap[convId]) {
            return state.msgListMap[convId];
        } else {
            return {
                pagination: { ...defaultPagination },
                isAllLoaded: false,
                msgList: [],
            }
        }
    },
    [TgGetters.getIsMsgListAllLoadedByConvId]: (state) => (convId: number): boolean => {
        if (state.msgListMap[convId]) {
            return state.msgListMap[convId].isAllLoaded;
        } else {
            return false;
        }
    },
    [TgGetters.getMemberList](state): TgMember[] {
        return state.memberList;
    },
    [TgGetters.getIsMemberListLoading](state): boolean {
        return state.isMemberLoading;
    },
    [TgGetters.getSelectMenu](state): string {
        return state.seletedMenu;
    },
    [TgGetters.getMeId](state): number {
        return state.meId;
    },
    [TgGetters.getIdList](state): TgUser[] {
        return state.idList;
    },
    [TgGetters.getMeIdIsLoading](state): boolean {
        return state.meIdIsLoading;
    },
    [TgGetters.getIsPaticipantsLoading](state): boolean {
        return state.isParticipantsLoading;
    },
    [TgGetters.getIsPaticipantsAllLoadedByName]: (state) => (convid: number): boolean => {
        if (state.chatroomParticipantsMap[convid]) {
            return state.chatroomParticipantsMap[convid].isAllLoaded;
        }
        return false;
    },
    [TgGetters.getChatroomGroupByName]: (state) => (convid: number): TgChatGroup => {
        if (state.chatroomParticipantsMap[convid]) {
            return state.chatroomParticipantsMap[convid];
        } else {
            return {
                pagination: { ...defaultPagination },
                isAllLoaded: false,
                userList: []
            }
        }
    },

    [TgGetters.getSearchTarget](state): string {
        return state.searchTarget;
    },
    [TgGetters.getSearchType](state): string {
        return state.searchType;
    },
    [TgGetters.getSearchContactList](state): TgUser[] {
        return state.searchingContact;
    },
    [TgGetters.getSearchConvList](state): TgConversation[] {
        return state.searchingConversation;
    },
    [TgGetters.getSearchChatList](state): TgChatToSearch[] {
        return state.searchingChat;
    },
    [TgGetters.getIsSearchContactLoading](state): boolean {
        return state.isSearchingContactLoading;
    },
    [TgGetters.getIsSearchConvLoading](state): boolean {
        return state.isSearchingConvLoading;
    },
    [TgGetters.getIsSearchChatLoading](state): boolean {
        return state.isSearchingChatLoading;
    },
    [TgGetters.getIsSearchContactAllLoaded](state): boolean {
        return state.isSearchingContactAllLoaded;
    },
    [TgGetters.getIsSearchConvAllLoaded](state): boolean {
        return state.isSearchingConvAllLoaded;
    },
    [TgGetters.getIsSearchChatAllLoaded](state): boolean {
        return state.isSearchingChatAllLoaded;
    },
    [TgGetters.getSearchContactPagination](state): TgPagination {
        return state.searchingContactPagination;
    },
    [TgGetters.getSearchConvPagination](state): TgPagination {
        return state.searchingConvPagination;
    },
    [TgGetters.getSearchChatPagination](state): TgPagination {
        return state.searchingChatPagination;
    },
    [TgGetters.getSearchMsgListMap]: (state) => (convId: number): TgMsgGroup => {
        if (state.searchMsgListMap[convId]) {
            return state.searchMsgListMap[convId];
        } else {
            return {
                pagination: { ...defaultPagination },
                isAllLoaded: false,
                msgList: [],
            }
        }
    },
    [TgGetters.getIsSearchMsgLoading](state): boolean {
        return state.isSearchingMsgLoading;
    },
    [TgGetters.getIsSearchMsgListAllLoadedByConvId]: (state) => (convId: number): boolean => {
        if (state.searchMsgListMap[convId]) {
            return state.searchMsgListMap[convId].isAllLoaded;
        } else {
            return false;
        }
    },


}

export const mutations: MutationTree<TgState> = {
    [TgMutations.setConvList](state, payload: { convList: TgConversation[], isAppend: boolean }) {
        if (payload.isAppend) {
            state.convList = state.convList.concat(payload.convList);
        } else {
            state.convList = payload.convList;
        }
    },
    [TgMutations.setIsConvLoading](state, payload: boolean) {
        state.isConvLoading = payload;
    },
    [TgMutations.setConvAllLoaded](state, payload: boolean) {
        state.isConvAllLoaded = payload;
    },
    [TgMutations.setChannelList](state, payload: { channelList: TgChannel[], isAppend: boolean }) {
        if (payload.isAppend) {
            state.channelList = state.channelList.concat(payload.channelList);
        } else {
            state.channelList = payload.channelList;
        }
    },
    [TgMutations.setIsChannelLoading](state, payload: boolean) {
        state.isChannelLoading = payload;
    },
    [TgMutations.setChannelAllLoaded](state, payload: boolean) {
        state.isChannelAllLoaded = payload;
    },
    [TgMutations.setChatList](state, payload: { chatList: TgChat[], isAppend: boolean }) {
        if (payload.isAppend) {
            state.chatList = state.chatList.concat(payload.chatList);
        } else {
            state.chatList = payload.chatList;
        }
    },
    [TgMutations.setIsChatLoading](state, payload: boolean) {
        state.isChatLoading = payload;
    },
    [TgMutations.setChatAllLoaded](state, payload: boolean) {
        state.isChatAllLoaded = payload;
    },
    [TgMutations.setUserList](state, payload: { userList: TgUser[], isAppend: boolean }) {
        if (payload.isAppend) {
            state.UserList = state.UserList.concat(payload.userList);
        } else {
            state.UserList = payload.userList;
        }
    },
    [TgMutations.setIsUserLoading](state, payload: boolean) {
        state.isUserLoading = payload;
    },
    [TgMutations.setUserAllLoaded](state, payload: boolean) {
        state.isUserAllLoaded = payload;
    },
    [TgMutations.setConvPagination](state, payload: TgPagination) {
        state.convPagination = payload;
    },
    [TgMutations.setChannelPagination](state, payload: TgPagination) {
        state.channelPagination = payload;
    },
    [TgMutations.setChatPagination](state, payload: TgPagination) {
        state.chatPagination = payload;
    },
    [TgMutations.setUserPagination](state, payload: TgPagination) {
        state.userPagination = payload;
    },
    [TgMutations.setSelectedConv](state, payload: TgConversation) {
        state.selectedConv = payload;
    },
    [TgMutations.setSelectedConvType](state, payload: string) {
        state.selectedConvType = payload;
    },
    [TgMutations.setIsMsgListLoading](state, payload: boolean) {
        state.isMsgListLoading = payload;
    },
    [TgMutations.setMsgListByConvId](state, payload: { convId: number, msgList: TgMsg[], isAppend: boolean }) {
        const msgGroup = state.msgListMap[payload.convId];
        if (!msgGroup) {
            state.msgListMap[payload.convId] = {
                msgList: payload.msgList,
                pagination: { ...defaultPagination },
                isAllLoaded: false,
            }
            return;
        }

        if (payload.isAppend) {
            state.msgListMap[payload.convId].msgList = msgGroup.msgList.concat(payload.msgList);
        } else {
            state.msgListMap[payload.convId].msgList = payload.msgList;
        }
    },
    [TgMutations.setMsgPaginationByConvId](state, payload: { convId: number, pagination: TgPagination }) {
        const msgGroup = state.msgListMap[payload.convId];
        if (msgGroup) {
            msgGroup.pagination = payload.pagination;
        } else {
            state.msgListMap[payload.convId] = {
                msgList: [],
                pagination: payload.pagination,
                isAllLoaded: false,
            }
        }
    },
    [TgMutations.setMsgAllLoadedByConvId](state, payload: { convId: number, isAllLoaded: boolean }) {
        const msgGroup = state.msgListMap[payload.convId];
        if (msgGroup) {
            msgGroup.isAllLoaded = payload.isAllLoaded;
        } else {
            state.msgListMap[payload.convId] = {
                msgList: [],
                pagination: { ...defaultPagination },
                isAllLoaded: payload.isAllLoaded,
            }
        }
    },
    [TgMutations.setMemberList](state, payload: { memberList: TgMember[], isAppend: boolean }) {
        if (payload.isAppend) {
            state.memberList = state.memberList.concat(payload.memberList);
        } else {
            state.memberList = payload.memberList;
        }
    },
    [TgMutations.setIsMemberListLoading](state, payload: boolean) {
        state.isMemberLoading = payload;
    },
    [TgMutations.resetAll](state) {
        Object.assign(state, {
            ...defaultState,
            meId: 0,
            seletedMenu: '1',
            convPagination: { ...defaultPagination },
            convList: [],
            channelList: [],
            chatList: [],
            UserList: [],
            msgListMap: {},
            chatroomParticipantsMap: {},
            memberList: [],
            channelPagination: { ...defaultPagination },
            chatPagination: { ...defaultPagination },
            userPagination: { ...defaultPagination },

        })
    },
    [TgMutations.setSelectMenu](state, payload: string) {
        state.seletedMenu = payload;
    },
    [TgMutations.setMeId](state, payload: number) {
        state.meId = payload;
    },
    [TgMutations.setIdList](state, payload: TgUser[]) {
        state.idList = payload;
    },
    [TgMutations.setMeIdIsLoading](state, payload: boolean) {
        state.meIdIsLoading = payload;
    },
    [TgMutations.setIsPaticipantsLoading](state, payload: boolean) {
        state.isParticipantsLoading = payload;
    },
    [TgMutations.setChatroomGroupByName](state, payload: { convid: number, userList: TgUser[], isAppend: boolean }) {
        const msgGroup = state.chatroomParticipantsMap[payload.convid];
        if (!msgGroup) {
            state.chatroomParticipantsMap[payload.convid] = {
                userList: payload.userList,
                pagination: { ...defaultPagination },
                isAllLoaded: false,
            }
            return;
        }
        if (payload.isAppend) {
            msgGroup.userList = msgGroup.userList.concat(payload.userList);
        } else {
            msgGroup.userList = payload.userList;
        }
    },
    [TgMutations.setParticipantsPaginationByName](state, payload: { convid: number, pagination: TgPagination }) {
        const msgGroup = state.chatroomParticipantsMap[payload.convid];
        if (msgGroup) {
            msgGroup.pagination = payload.pagination;
        } else {
            state.chatroomParticipantsMap[payload.convid] = {
                userList: [],
                pagination: payload.pagination,
                isAllLoaded: false,
            }
        }
    },
    [TgMutations.setParticipantsAllLoadedByName](state, payload: { convid: number, isAllLoaded: boolean }) {
        const msgGroup = state.chatroomParticipantsMap[payload.convid];
        if (msgGroup) {
            msgGroup.isAllLoaded = payload.isAllLoaded;
        } else {
            state.chatroomParticipantsMap[payload.convid] = {
                userList: [],
                pagination: { ...defaultPagination },
                isAllLoaded: payload.isAllLoaded,
            }
        }
    },
    [TgMutations.setSearchTarget](state, payload: string): void {
        state.searchTarget = payload
    },
    [TgMutations.setSearchType](state, payload: string): void {
        state.searchType = payload
    },
    [TgMutations.setSearchContactList](state, payload: { contactList: TgUser[], isAppend: boolean }) {
        if (payload.isAppend) {
            state.searchingContact = state.searchingContact.concat(payload.contactList);
        } else {
            state.searchingContact = payload.contactList;
        }
    },
    [TgMutations.setSearchConvList](state, payload: { convList: TgConversation[], isAppend: boolean }) {
        if (payload.isAppend) {
            state.searchingConversation = state.searchingConversation.concat(payload.convList);
        } else {
            state.searchingConversation = payload.convList;
        }
    },
    [TgMutations.setSearchChatList](state, payload: { chatList: TgChatToSearch[], isAppend: boolean }) {
        if (payload.isAppend) {
            state.searchingChat = state.searchingChat.concat(payload.chatList);
        } else {
            state.searchingChat = payload.chatList;
        }
    },
    [TgMutations.setIsSearchContactLoading](state, payload: boolean) {
        state.isSearchingContactLoading = payload;
    },
    [TgMutations.setIsSearchConvLoading](state, payload: boolean) {
        state.isSearchingConvLoading = payload;
    },
    [TgMutations.setIsSearchChatLoading](state, payload: boolean) {
        state.isSearchingChatLoading = payload;
    },
    [TgMutations.setIsSearchContactAllLoaded](state, payload: boolean) {
        state.isSearchingContactAllLoaded = payload;
    },
    [TgMutations.setIsSearchConvAllLoaded](state, payload: boolean) {
        state.isSearchingConvAllLoaded = payload;
    },
    [TgMutations.setIsSearchChatAllLoaded](state, payload: boolean) {
        state.isSearchingChatAllLoaded = payload;
    },
    [TgMutations.setSearchContactPagination](state, payload: TgPagination) {
        state.searchingContactPagination = payload;
    },
    [TgMutations.setSearchConvPagination](state, payload: TgPagination) {
        state.searchingConvPagination = payload;
    },
    [TgMutations.setSearchChatPagination](state, payload: TgPagination) {
        state.searchingChatPagination = payload;
    },
    [TgMutations.setSearchMsgListByConvId](state, payload: { convId: number, msgList: TgMsg[], isAppend: boolean }) {
        const msgGroup = state.searchMsgListMap[payload.convId];
        if (!msgGroup) {
            state.searchMsgListMap[payload.convId] = {
                msgList: payload.msgList,
                pagination: { ...defaultPagination },
                isAllLoaded: false,
            }
            return;
        }

        if (payload.isAppend) {
            state.searchMsgListMap[payload.convId].msgList = msgGroup.msgList.concat(payload.msgList);
        } else {
            state.searchMsgListMap[payload.convId].msgList = payload.msgList;
        }
    },
    [TgMutations.setIsSearchMsgLoading](state, payload: boolean) {
        state.isSearchingMsgLoading = payload;
    },
    [TgMutations.setSearchMsgPaginationByConvId](state, payload: { convId: number, pagination: TgPagination }) {
        const msgGroup = state.searchMsgListMap[payload.convId];
        if (msgGroup) {
            msgGroup.pagination = payload.pagination;
        } else {
            state.searchMsgListMap[payload.convId] = {
                msgList: [],
                pagination: payload.pagination,
                isAllLoaded: false,
            }
        }
    },
    [TgMutations.setSearchMsgAllLoadedByConvId](state, payload: { convId: number, isAllLoaded: boolean }) {
        const msgGroup = state.searchMsgListMap[payload.convId];
        if (msgGroup) {
            msgGroup.isAllLoaded = payload.isAllLoaded;
        } else {
            state.searchMsgListMap[payload.convId] = {
                msgList: [],
                pagination: { ...defaultPagination },
                isAllLoaded: payload.isAllLoaded,
            }
        }
    },
    [TgMutations.resetSearch](state) {
        Object.assign(state, {
            searchingContact: [],
            searchingConversation: [],
            searchingChat: [],
            isSearchingContactLoading: false,
            isSearchingConvLoading: false,
            isSearchingChatLoading: false,
            isSearchingContactAllLoaded: false,
            isSearchingConvAllLoaded: false,
            isSearchingChatAllLoaded: false,
            searchingContactPagination: { ...defaultPagination },
            searchingConvPagination: { ...defaultPagination },
            searchingChatPagination: { ...defaultPagination },
            searchMsgListMap: {},
            isSearchingMsgLoading: false,
        })
    },


}

export const actions: ActionTree<TgState, RootState> = {
    async [TgActions.asyncGetConvListByUidAndTgId]({ commit, getters }: ActionContext<TgState, RootState>, { projId, uid, tgId, isAppend }: { projId: string, uid: string, tgId: number, isAppend: boolean }) {
        try {
            commit(TgMutations.setIsConvLoading, true);
            const convPagination = getters[TgGetters.getConvPagination];
            const convList = await tgAPI.asyncGetConvListByUidAndTgId({ projid: projId, uid: uid, tgid: tgId, ...convPagination });
            commit(TgMutations.setConvList, { convList, isAppend });
            commit(TgMutations.setConvPagination, { ...convPagination, page: convPagination.page + 1 });
            if (convList.length < convPagination.limit) {
                commit(TgMutations.setConvAllLoaded, true);
            }
        } catch (err) {
            commit(TgMutations.setConvAllLoaded, true);
            console.log(err)
        } finally {
            commit(TgMutations.setIsConvLoading, false);
        }
    },
    async [TgActions.asyncGetChannelListByUidAndTgId]({ commit, getters }: ActionContext<TgState, RootState>, { projId, uid, tgId, isAppend }: { projId: string, uid: string, tgId: number, isAppend: boolean }) {
        try {
            commit(TgMutations.setIsChannelLoading, true);
            const channelPagination = getters[TgGetters.getChannelPagination];
            const channelList = await tgAPI.asyncGetChannelListByUidAndTgId({ projid: projId, uid: uid, tgid: tgId, ...channelPagination });
            commit(TgMutations.setChannelList, { channelList, isAppend });
            commit(TgMutations.setChannelPagination, { ...channelPagination, page: channelPagination.page + 1 });
            if (channelList.length < channelPagination.limit) {
                commit(TgMutations.setChannelAllLoaded, true);
            }
        } catch (err) {
            commit(TgMutations.setChannelAllLoaded, true);
            console.log(err)
        } finally {
            commit(TgMutations.setIsChannelLoading, false);
        }
    },
    async [TgActions.asyncGetChatListByUidAndTgId]({ commit, getters }: ActionContext<TgState, RootState>, { projId, uid, tgId, isAppend }: { projId: string, uid: string, tgId: number, isAppend: boolean }) {
        try {
            commit(TgMutations.setIsChatLoading, true);
            const chatPagination = getters[TgGetters.getChatPagination];
            const chatList = await tgAPI.asyncGetChatListByUidAndTgId({ projid: projId, uid: uid, tgid: tgId, ...chatPagination });
            commit(TgMutations.setChatList, { chatList, isAppend });
            commit(TgMutations.setChatPagination, { ...chatPagination, page: chatPagination.page + 1 });
            if (chatList.length < chatPagination.limit) {
                commit(TgMutations.setChatAllLoaded, true);
            }
        } catch (err) {
            commit(TgMutations.setChatAllLoaded, true);
            console.log(err)
        } finally {
            commit(TgMutations.setIsChatLoading, false);
        }
    },
    async [TgActions.asyncGetUserListByUidAndTgId]({ commit, getters }: ActionContext<TgState, RootState>, { projId, uid, tgId, isAppend }: { projId: string, uid: string, tgId: number, isAppend: boolean }) {
        try {
            commit(TgMutations.setIsUserLoading, true);
            const userPagination = getters[TgGetters.getUserPagination];
            const userList = await tgAPI.asyncGetUserListByUidAndTgId({ projid: projId, uid: uid, tgid: tgId, ...userPagination });
            commit(TgMutations.setUserList, { userList, isAppend });
            commit(TgMutations.setUserPagination, { ...userPagination, page: userPagination.page + 1 });
            if (userList.length < userPagination.limit) {
                commit(TgMutations.setUserAllLoaded, true);
            }
        } catch (err) {
            commit(TgMutations.setUserAllLoaded, true);
            console.log(err)
        } finally {
            commit(TgMutations.setIsUserLoading, false);
        }
    },
    async [TgActions.asyncGetSearchingContactByUidAndTgId]({ commit, getters }: ActionContext<TgState, RootState>,
        { projId, uid, tgId, isAppend, target }: { projId: string, uid: string, tgId: number, isAppend: boolean, target: string }) {
        try {
            commit(TgMutations.setIsSearchContactLoading, true);
            const searchContactPagination = getters[TgGetters.getSearchContactPagination];
            const contactList = await tgAPI.asyncFuzzySearchContactForTg({ projid: projId, uid: uid, tgid: tgId, ...searchContactPagination, target: target });
            commit(TgMutations.setSearchContactList, { contactList, isAppend });
            commit(TgMutations.setSearchContactPagination, { ...searchContactPagination, page: searchContactPagination.page + 1 });
            if (contactList.length < searchContactPagination.limit) {
                commit(TgMutations.setIsSearchContactAllLoaded, true);
            }
        } catch (err) {
            commit(TgMutations.setIsSearchContactAllLoaded, true);
            console.log(err)
        } finally {
            commit(TgMutations.setIsSearchContactLoading, false);
        }
    },
    async [TgActions.asyncGetSearchingConvByUidAndTgId]({ commit, getters }: ActionContext<TgState, RootState>,
        { projId, uid, tgId, isAppend, target }: { projId: string, uid: string, tgId: number, isAppend: boolean, target: string }) {
        try {
            commit(TgMutations.setIsSearchConvLoading, true);
            const searchConvPagination = getters[TgGetters.getSearchConvPagination];
            const convList = await tgAPI.asyncFuzzySearchChatForTg({ projid: projId, uid: uid, tgid: tgId, ...searchConvPagination, target: target });
            commit(TgMutations.setSearchConvList, { convList, isAppend });
            commit(TgMutations.setSearchConvPagination, { ...searchConvPagination, page: searchConvPagination.page + 1 });
            if (convList.length < searchConvPagination.limit) {
                commit(TgMutations.setIsSearchConvAllLoaded, true);
            }
        } catch (err) {
            commit(TgMutations.setIsSearchConvAllLoaded, true);
            console.log(err)
        } finally {
            commit(TgMutations.setIsSearchConvLoading, false);
        }
    },
    async [TgActions.asyncGetSearchingChatByUidAndTgId]({ commit, getters }: ActionContext<TgState, RootState>,
        { projId, uid, tgId, isAppend, target }: { projId: string, uid: string, tgId: number, isAppend: boolean, target: string }) {
        try {
            commit(TgMutations.setIsSearchChatLoading, true);
            const searchChatPagination = getters[TgGetters.getSearchChatPagination];
            const chatList = await tgAPI.asyncGetChatListByUser({ projid: projId, uid: uid, tgid: tgId, ...searchChatPagination, target: target });
            commit(TgMutations.setSearchChatList, { chatList, isAppend });
            commit(TgMutations.setSearchChatPagination, { ...searchChatPagination, page: searchChatPagination.page + 1 });
            if (chatList.length < searchChatPagination.limit) {
                commit(TgMutations.setIsSearchChatAllLoaded, true);
            }
        } catch (err) {
            commit(TgMutations.setIsSearchChatAllLoaded, true);
            console.log(err)
        } finally {
            commit(TgMutations.setIsSearchChatLoading, false);
        }
    },
    async [TgActions.asyncGetMsgListByTgIdAndConvId]({ commit, getters }: ActionContext<TgState, RootState>, { projId, uid, tgId, convid }: { projId: string, uid: string, tgId: number, convid: number }) {
        try {
            commit(TgMutations.setIsMsgListLoading, true);
            const msgGroup = getters[TgGetters.getMsgGroupByConvId](convid);
            const currentPagination = msgGroup.pagination;
            // TODO to be changed to function map or to be changed in backend.
            let msgList: TgMsg[] = [];
            msgList = await tgAPI.asyncGetTgMsgsByTgConvId({ projid: projId, uid: uid, tgid: tgId, convid: convid, ...currentPagination });

            // msgList = msgList ? msgList : [];
            if (msgList.length < currentPagination.limit) {
                commit(TgMutations.setMsgAllLoadedByConvId, { convId: convid, isAllLoaded: true });
            }

            commit(TgMutations.setMsgListByConvId, { convId: convid, msgList: msgList, isAppend: true });
            commit(TgMutations.setMsgPaginationByConvId, {
                convId: convid,
                pagination: {
                    ...currentPagination,
                    page: currentPagination.page + 1,
                }
            })
        } catch (err) {
            commit(TgMutations.setMsgAllLoadedByConvId, { convId: convid, isAllLoaded: true });
            console.log(err)
        } finally {
            commit(TgMutations.setIsMsgListLoading, false);
        }
    },
    async [TgActions.asyncGetSearchingMsgByConvIdAndTarget]({ commit, getters }: ActionContext<TgState, RootState>,
        { projId, uid, tgId, convid, target, isAppend }: { projId: string, uid: string, tgId: number, convid: number, target: string, isAppend: boolean }) {
        try {
            commit(TgMutations.setIsSearchMsgLoading, true);
            const msgGroup = getters[TgGetters.getSearchMsgListMap](convid);
            const currentPagination = msgGroup.pagination;
            // TODO to be changed to function map or to be changed in backend.
            let msgList: TgMsg[] = [];
            msgList = await tgAPI.asyncgetMsgListForSearchResultOfChat({ projid: projId, uid: uid, tgid: tgId, convid: convid, target: target, ...currentPagination });

            // msgList = msgList ? msgList : [];
            if (msgList.length < currentPagination.limit) {
                commit(TgMutations.setSearchMsgAllLoadedByConvId, { convId: convid, isAllLoaded: true });
            }

            commit(TgMutations.setSearchMsgListByConvId, { convId: convid, msgList: msgList, isAppend: isAppend });
            commit(TgMutations.setSearchMsgPaginationByConvId, {
                convId: convid,
                pagination: {
                    ...currentPagination,
                    page: currentPagination.page + 1,
                }
            })
        } catch (err) {
            commit(TgMutations.setSearchMsgAllLoadedByConvId, { convId: convid, isAllLoaded: true });
            console.log(err)
        } finally {
            commit(TgMutations.setIsSearchMsgLoading, false);
        }
    },

    async [TgActions.asyncGetMeId]({ commit, getters }: ActionContext<TgState, RootState>, { projid, uid }: { projid: string, uid: string }) {
        try {
            commit(TgMutations.setMeIdIsLoading, true);
            const nowId = getters[TgGetters.getMeId];

            const ids = await tgAPI.asyncGetTgIdByProjIdAndUid({ projid: projid, uid: uid });
            commit(TgMutations.setIdList, ids);
            if (ids.length > 0) {
                commit(TgMutations.setMeId, nowId === 0 ? ids[0].Id : nowId);
            } else {
                commit(TgMutations.setConvAllLoaded, true);
            }
        } catch (err) {
            console.log(err)
        } finally {
            commit(TgMutations.setMeIdIsLoading, false);
        }
    },
    async [TgActions.asyncGetParticipantsByUidAndTgIdAndConvId]({ commit, getters }: ActionContext<TgState, RootState>, { projid, uid, tgid, convid }: { projid: string, uid: string, tgid: string, convid: string }) {
        try {
            commit(TgMutations.setIsPaticipantsLoading, true);
            const chatroomGroup = getters[TgGetters.getChatroomGroupByName](convid);
            const currentPagination = chatroomGroup.pagination;
            let userList: TgUser[] = [];
            userList = await tgAPI.asyncGetParticipantsByUidAndTgIdAndConvId({ projid: projid, uid: uid, tgid: tgid, convid: convid, ...currentPagination });
            if (userList.length < currentPagination.limit) {
                commit(TgMutations.setParticipantsAllLoadedByName, { convid: convid, isAllLoaded: true });
            }
            commit(TgMutations.setChatroomGroupByName, { convid: convid, userList: userList, isAppend: true });
            commit(TgMutations.setParticipantsPaginationByName, {
                convid: convid,
                pagination: {
                    ...currentPagination,
                    page: currentPagination.page + 1,
                }
            });
        } catch (err) {
            commit(TgMutations.setParticipantsAllLoadedByName, { convid: convid, isAllLoaded: true });
            console.log(err);
        } finally {
            commit(TgMutations.setIsPaticipantsLoading, false);
        }
    },
    async [TgActions.asyncGetSearchingMsgByConvIdAndUserId]({ commit, getters }: ActionContext<TgState, RootState>,
        { projId, uid, tgId, convid, userId, isAppend }: { projId: string, uid: string, tgId: number, convid: number, userId: number, isAppend: boolean }) {
        try {
            commit(TgMutations.setIsSearchMsgLoading, true);
            const msgGroup = getters[TgGetters.getSearchMsgListMap](convid);
            const currentPagination = isAppend ? msgGroup.pagination : defaultPagination;
            // TODO to be changed to function map or to be changed in backend.
            let msgList: TgMsg[] = [];
            msgList = await tgAPI.asyncGetMsgListByConvIdAndUserId({ projid: projId, uid: uid, tgid: tgId, convid: convid, userid: userId, ...currentPagination });

            // msgList = msgList ? msgList : [];
            if (msgList.length < currentPagination.limit) {
                commit(TgMutations.setSearchMsgAllLoadedByConvId, { convId: convid, isAllLoaded: true });
            }

            commit(TgMutations.setSearchMsgListByConvId, { convId: convid, msgList: msgList, isAppend: isAppend });
            commit(TgMutations.setSearchMsgPaginationByConvId, {
                convId: convid,
                pagination: {
                    ...currentPagination,
                    page: currentPagination.page + 1,
                }
            })
        } catch (err) {
            commit(TgMutations.setSearchMsgAllLoadedByConvId, { convId: convid, isAllLoaded: true });
            console.log(err)
        } finally {
            commit(TgMutations.setIsSearchMsgLoading, false);
        }
    },

}

export const telegram: Module<TgState, RootState> = {
    namespaced: true,
    state,
    actions,
    getters,
    mutations,
}

